/*
 * Created by Ali Simsek on 5/14/20, 2:02 PM
 * Copyright (c) 2020 Carla Car Rental, Inc. All rights reserved.
 * Last modified 5/13/20, 6:06 PM
 */

import React, { Component } from 'react'
import styled from 'styled-components'
import { El } from './layout'
import { number, string } from 'prop-types'

class RawLoading extends Component {
  static propTypes = {
    size: number,
    color: string
  }

  render() {
    return (
      <El {...this.props}>
        <svg className='loading' viewBox='0 0 50 50'>
          <circle className='path' cx='25' cy='25' r='20' fill='none' strokeWidth='5' />
        </svg>
      </El>
    )
  }
}

const Loading = styled(RawLoading)`
  position: relative;
  min-width: ${(props) => props.size || props.width || 50}px;
  min-height: ${(props) => props.size || props.width || 50}px;
  svg {
    animation: rotate 2s linear infinite;
    z-index: 2;
    margin: auto;
    width: ${(props) => props.size || props.width || 50}px;
    height: ${(props) => props.size || props.width || 50}px;
    .path {
      stroke: ${(props) => props.color || '#FF7D0E'};
      stroke-linecap: round;
      animation: dash 1s ease-in-out infinite;
    }
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
`

export default Loading
